import React from "react";
import Header from "./Header";

const TermsAndConditions = () => {
  return (
    <div className="legal-container">
        <Header/>
        <div>
            <h1>Terms & Conditions</h1>
            <p><strong>Last Updated:</strong> 12/1/2026</p>

            <h2>1. Introduction</h2>
            <p>
                Welcome to Nkechukwu's Vision LTD (“NV”, “we”, “our”, or “us”). These Terms
                and Conditions govern your use of our website, mobile application, and
                related services (collectively, the “Platform”).
            </p>

            <h2>2. Platform Purpose</h2>
            <p>
                NV provides a technology platform designed to facilitate the sale,
                auction, authentication, and secure delivery of jewelry and art pieces.
            </p>

            <h2>3. User Responsibilities</h2>
            <ul>
                <li>Provide accurate and lawful information</li>
                <li>Respect intellectual property rights</li>
                <li>Refrain from fraudulent or misleading activity</li>
            </ul>

            <h2>4. Auctions & Transactions</h2>
            <p>
                All bids and purchases made through the Platform are binding. NV is not
                responsible for disputes between buyers and sellers but may assist in
                resolution where appropriate.
            </p>

            <h2>5. Authentication & Delivery</h2>
            <p>
                Authentication services are provided using reasonable industry standards
                but do not constitute legal guarantees. Secure delivery is facilitated
                through third-party providers.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
                NV shall not be liable for indirect, incidental, or consequential damages
                arising from Platform use.
            </p>

            <h2>7. Changes</h2>
            <p>
                NV reserves the right to modify these Terms at any time. Continued use of
                the Platform constitutes acceptance of the updated Terms.
            </p>

            <h2>8. Contact</h2>
            <p>Email: nkechukwu@nv.luxury</p>
        </div>
        
    </div>
  );
};

export default TermsAndConditions;
